import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { Row, Column } from 'web-ui-components/lib/global/layout';
import { Divider } from 'web-ui-components/lib/atoms/layout';
import { Title } from 'web-ui-components/lib/atoms/text';
import { contentWrapper as CreditTable } from '../../../bacs/components/BacsTable/CreditTable/CreditTable';
import BacsCreditPaymentDetails from '../PaymentDetails/BacsCreditPaymentDetails';
import { bacsPaymentProptypes } from '../../../states/managePayments/propTypes';
import PrintHelper from 'print-helper-lib';

export const ViewBacsCredit = ({ mandate, brandId }) => (
	<div className="u-background-color-grey-tint-95 u-padding-2">
		<PrintHelper className="web-ui-components" brandId={brandId} showPrintTopIcon showPrintBottomIcon={false} />
		<Title size="h4">{get(mandate, 'mandateType', '')}</Title>
		<Divider />
		<Row className="u-component-spacing">
			<Column sm={18}>
				<BacsCreditPaymentDetails mandate={mandate} />
			</Column>
		</Row>
		<CreditTable bacsDetails={mandate} showTotal={false} />
	</div>
);

ViewBacsCredit.propTypes = {
	mandate: PropTypes.shape(bacsPaymentProptypes).isRequired,
	brandId: PropTypes.string.isRequired,
};
export default ViewBacsCredit;
